import { Room } from 'livekit-client'

export type OutGoingDataMessageType = 'response' | 'next'

interface OutGoingDataMessage {
  type: OutGoingDataMessageType
  content?: string | undefined
  timestamp?: number // Optional field for future use
}

class DataMessageSender {
  private room: Room

  constructor(room: Room) {
    this.room = room
  }

  private sendDataMessage(type: OutGoingDataMessageType, content?: string): void {
    if (this.room !== undefined) {
      const encoder = new TextEncoder()
      const dataMessage: OutGoingDataMessage = {
        type: type,
        ...(content !== undefined && { content })
      }
      const data = encoder.encode(JSON.stringify(dataMessage))
      this.room.localParticipant?.publishData(data, { reliable: true })
    } else {
      console.log(`warn: room is undefined`)
    }
  }

  sendResponse(content: string): void {
    this.sendDataMessage('response', content)
  }

  sendNext(): void {
    this.sendDataMessage('next')
  }
}

export default DataMessageSender
